import { useMutation } from '@tanstack/react-query';
import { forgotPasswordValidateTotp } from './api';
import { ForgotPasswordValidateTotpPayload } from '@/api/v1/users/forgotPasswordValidateTotpApi';
import { useEffect, useState } from 'react';
import { getLoginPath } from '@/bundle/Auth/LoginFlow/LoginPage/path/path';
import { AuthLayout } from '../../ui/AuthLayout/AuthLayout';
import { LayoutSpinner } from '@/bundle/Layouts/styles';
import { useNavigate, useSearchParams } from 'react-router';
import { useForgotPasswordNavigateToStep } from '../hooks/useForgotPasswordNavigateToStep';
import { ACTIVATION_TOKEN_INVALID_RESPONSE } from '@/api/const';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { getForgotPasswordLinkExpiredPath } from '../path';
import { showSnackbarResponseError } from '@/helpers/helpers';

export const ForgotPasswordValidateTotpPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const navigateToStep = useForgotPasswordNavigateToStep();
  const [isValidatingTotp, setIsValidatingTotp] = useState(true);

  const { mutate } = useMutation({
    mutationKey: ['validate_totp'],
    mutationFn: (payload: ForgotPasswordValidateTotpPayload) => {
      return forgotPasswordValidateTotp(payload);
    },
    onSuccess(response) {
      if (response?.error) {
        const errorContent = getResponseError(response?.error);

        if (errorContent === ACTIVATION_TOKEN_INVALID_RESPONSE) {
          return navigate(getForgotPasswordLinkExpiredPath());
        }

        return showSnackbarResponseError(response?.error);
      }

      navigateToStep(response?.body);
    },
    onSettled: () => {
      setIsValidatingTotp(false);
    },
  });

  useEffect(() => {
    const token = searchParams.get('token');
    const userId = searchParams.get('user_id');

    if (!token || !userId) {
      navigate(getLoginPath());

      return;
    }

    const payload = {
      token,
      user_id: userId,
    };

    amplitudeService.logEvent(AMPLITUDE_EVENTS.ForgotPasswordValidateTotp);

    mutate(payload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isValidatingTotp) {
    return (
      <AuthLayout>
        <LayoutSpinner />
      </AuthLayout>
    );
  }

  return null;
};
